import { render, staticRenderFns } from "./switchType.vue?vue&type=template&id=6cdd5300&scoped=true&"
import script from "./switchType.vue?vue&type=script&lang=js&"
export * from "./switchType.vue?vue&type=script&lang=js&"
import style0 from "./switchType.vue?vue&type=style&index=0&id=6cdd5300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdd5300",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/builds/master/frontend/frontend-universe/components/SvgIcon.vue').default})
